import { useAuthStore } from '@/stores/authStore'

export default function redirectIfAuth() {
    const auth = useAuthStore()

    auth.loadUser()

    if (auth.user) return '/home'
}
